/* eslint-disable @atlaskit/design-system/use-tokens-space */
import React from 'react';
import { css } from '@compiled/react';

import Image from '@atlaskit/image';

import GuestOnboardingImageLight from './img/Guest-Onboarding-Light.svg';
import GuestOnboardingImageDark from './img/Guest-Onboarding-Dark.svg';

const imageStyles = css({
	width: '74%',
	marginTop: '5%',
	marginLeft: '12%',
	height: '75%',
	objectFit: 'contain',
	objectPosition: 'center',
});

type ImageProps = {
	alt: string;
};

export function GuestOnboardingModalImage({ alt }: ImageProps) {
	return (
		<Image
			alt={alt}
			src={GuestOnboardingImageLight}
			srcDark={GuestOnboardingImageDark}
			css={imageStyles}
		/>
	);
}
